import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, Output, inject, PLATFORM_ID } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';

type SidebarMenu = {
  tooltip: string;
  route: string;
  icon: { paths: string[] };
  externalUrl?: string;
  children?: SidebarMenuChild[];
};

type SidebarMenuChild = {
  tooltip: string;
  route: string;
};

@Component({
  selector: 'app-sidebar',
  imports: [RouterLink, RouterLinkActive, CommonModule],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
})
export class Sidebar {
  private readonly platformId = inject(PLATFORM_ID);
  activeMenu: string | null = null;
  @Output() collapsedChange = new EventEmitter<boolean>();

  isCollapsed = false;

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
    this.collapsedChange.emit(this.isCollapsed);
  }

  toggleMenu(menu: SidebarMenu) {
    if (menu.externalUrl) {
      window.location.replace(menu.externalUrl);
      return;
    }

    if (!menu.children) {
      this.router.navigate([menu.route]);
      return;
    }

    this.activeMenu = this.activeMenu === menu.tooltip ? null : menu.tooltip;
  }

  isMenuActive(menu: SidebarMenu): boolean {
    if (!menu?.route || menu?.externalUrl) return false;
    return this.router.url === menu.route || this.router.url.startsWith(`${menu.route}/`);
  }

  isChildActive(child: SidebarMenuChild): boolean {
    return this.router.url === child.route || this.router.url.startsWith(`${child.route}/`);
  }

  constructor(private router: Router) { }

  get visibleMenus(): SidebarMenu[] {
    if (!isPlatformBrowser(this.platformId)) {
      return this.menus.filter((m) => m.route.startsWith('/kga-website'));
    }
    const authed =
      sessionStorage.getItem('otpVerified') === 'true' && !!localStorage.getItem('userToken');
    return authed ? this.menus : this.menus.filter((m) => m.route.startsWith('/kga-website'));
  }

  menus: SidebarMenu[] = [
    // {
    //   tooltip: 'Member Directory',
    //   route: '/member_directory/member',
    //   icon: {
    //     paths: [
    //       'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2',
    //       'M16 3.128a4 4 0 0 1 0 7.744',
    //       'M22 21v-2a4 4 0 0 0-3-3.87',
    //       'M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0-8 0'
    //     ]
    //   }
    // },
    // {
    //   tooltip: 'e-NACH',
    //   route: '/enach/master',
    //   icon: {
    //     paths: [
    //       'M2 5h20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z',
    //       'M2 10h20'
    //     ]
    //   },
    //   // children: [
    //   //   {
    //   //     tooltip: 'e-Nach mandate registration',
    //   //     route: '/enach/master'
    //   //   }
    //   // ],
    // },
    // {
    //   tooltip: 'Club',
    //   route: '/club',
    //   icon: {
    //     paths: [
    //       'M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8',
    //       'M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z'
    //     ]
    //   },
    //   children: [
    //     // {
    //     //   tooltip: 'View Affiliated Club',
    //     //   route: '/affiliated_club/master'
    //     // },
    //     {
    //       tooltip: 'View Club Facility',
    //       route: '/club_facility/master'
    //     },
    //     // {
    //     //   tooltip: 'Club Office Contacts',
    //     //   route: '/contact_office/master'
    //     // },
    //     // {
    //     //   tooltip: 'Managing Committee',
    //     //   route: '/online-payments/transaction-history'
    //     // },
    //     // {
    //     //   tooltip: 'Image Gallery',
    //     //   route: '/online-payments/transaction-history'
    //     // },
    //     // {
    //     //   tooltip: 'Club Rules',
    //     //   route: '/online-payments/transaction-history'
    //     // },
    //     // {
    //     //   tooltip: 'Bye-laws',
    //     //   route: '/online-payments/transaction-history'
    //     // }
    //   ]
    // },
    // {
    //   tooltip: 'Club Documents',
    //   route: '/club-documents',
    //   icon: {
    //     paths: [
    //       'm6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2'
    //     ]
    //   }
    // },
    // {
    //   tooltip: 'Newsletters',
    //   route: '/newsletters',
    //   icon: {
    //     paths: [
    //       'M15 18h-5',
    //       'M18 14h-8',
    //       'M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-4 0v-9a2 2 0 0 1 2-2h2',
    //       'M10 6h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1z'
    //     ]
    //   }
    // },
    // {
    //   tooltip: 'Online Payments',
    //   route: '/online-payments',
    //   icon: {
    //     paths: [
    //       'M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1',
    //       'M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4'
    //     ]
    //   },
    //   children: [
    //     {
    //       tooltip: 'Transaction History',
    //       route: '/transaction_history/master'
    //     }
    //   ]
    // },
    {
      tooltip: 'Member Ledger View',
      route: '/member_ledger/master',
      icon: {
        paths: [
          'M7 13h3.75c1.393 0 2.728 -0.474 3.713 -1.318C15.447 10.838 16 9.693 16 8.5c0 -1.193 -0.553 -2.338 -1.537 -3.182C13.478 4.474 12.143 4 10.75 4H7',
          'M7 13l8.2 7',
          'M7 8.5h11',
          'M11 4h7'
        ]
      }
    },
    {
      tooltip: 'Monthly Bills',
      route: '/monthly_bill/master',
      icon: {
        paths: [
          'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z',
          'M14 2v6h6',
          'M16 13H8',
          'M16 17H8'
        ]
      }
    },
    // {
    //   tooltip: 'Receipt',
    //   route: '/receipt/master',
    //   icon: {
    //     paths: [
    //       'M6 2H18C19.1 2 20 2.9 20 4V22L18 20.5L16 22L14 20.5L12 22L10 20.5L8 22L6 20.5L4 22V4C4 2.9 4.9 2 6 2Z',
    //       'M8 7H16',
    //       'M8 11H16',
    //       'M8 15H16'
    //     ]
    //   }
    // },
    {
      tooltip: 'About Us',
      route: '/kga-website/master-kga',
      icon: {
        paths: [
          'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z',
          'M12 16v-4',
          'M12 8h.01'
        ]
      }
    },
    {
      tooltip: 'Contact Us',
      route: '/kga-website/contact-us',
      icon: {
        paths: [
          'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z'
        ]
      }
    },
    {
      tooltip: 'Terms & Conditions',
      route: '/kga-website/terms-conditions',
      icon: {
        paths: [
          'M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2',
          'M9 2h6v4H9z',
          'M8 11h8',
          'M8 15h8'
        ]
      }
    },
    // {
    //   tooltip: 'Refund Policy',
    //   route: '/kga-website/cancellation-refund-policy',
    //   icon: {
    //     paths: [
    //       'M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8',
    //       'M3 3v5h5'
    //     ]
    //   }
    // },
    // {
    //   tooltip: 'Shipping Policy',
    //   route: '/kga-website/shipping-policy',
    //   icon: {
    //     paths: [
    //       'M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z',
    //       'M3.27 6.96L12 12.01l8.73-5.05',
    //       'M12 22.08V12'
    //     ]
    //   }
    // },
    {
      tooltip: 'Privacy Policy',
      route: '/kga-website/privacy-policy',
      icon: {
        paths: [
          'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z'
        ]
      }
    },
    // {
    //   tooltip: 'Views & Pay Bills',
    //   route: '/member_ledger/master',
    //   icon: {
    //     // Reuse the icon style from the original Member Ledger View item
    //     paths: [
    //       'M7 13h3.75c1.393 0 2.728 -0.474 3.713 -1.318C15.447 10.838 16 9.693 16 8.5c0 -1.193 -0.553 -2.338 -1.537 -3.182C13.478 4.474 12.143 4 10.75 4H7',
    //       'M7 13l8.2 7',
    //       'M7 8.5h11',
    //       'M11 4h7'
    //     ]
    //   },
    //   children: [
    //     {
    //       tooltip: 'Member Ledger View',
    //       route: '/member_ledger/master'
    //     },
    //     {
    //       tooltip: 'Month Bill',
    //       route: '/monthly_bill/master'
    //     }
    //   ]
    // },
    // {
    //   tooltip: 'KGA',
    //   route: '/kga-website',
    //   icon: {
    //     paths: [
    //       'M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2z',
    //       'M2 12h20',
    //       'M12 2a15.3 15.3 0 0 1 0 20',
    //       'M12 2a15.3 15.3 0 0 0 0 20'
    //     ]
    //   },
    //   children: [
    //     {
    //       tooltip: 'About Us',
    //       route: '/kga-website/master-kga'
    //     },
    //     {
    //       tooltip: 'Contact Us',
    //       route: '/kga-website/contact-us'
    //     },
    //     {
    //       tooltip: 'Terms & Conditions',
    //       route: '/kga-website/terms-conditions'
    //     },
    //     {
    //       tooltip: 'Refund Policy',
    //       route: '/kga-website/cancellation-refund-policy'
    //     },
    //     {
    //       tooltip: 'Shipping Policy',
    //       route: '/kga-website/shipping-policy'
    //     },
    //     {
    //       tooltip: 'Privacy Policy',
    //       route: '/sitr-url/site-home',
    //     }
    //   ]
    // },
    // {
    //   tooltip: '',
    //   route: '/site-policy',
    //   externalUrl: 'https://kga-masterlogin-webapp-uat.azurewebsites.net/privacy_policy',
    //   icon: {
    //     paths: [
    //       'M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z'
    //     ]
    //   },
    //   // children: [
    //   //   {
    //   //     tooltip: 'Privacy Policy',
    //   //     route: '/site_policy/privacy_policy'
    //   //   },
    //   //   {
    //   //     tooltip: 'Refund Policy',
    //   //     route: '/site_policy/refund_policy'
    //   //   },
    //   //   {
    //   //     tooltip: 'Terms & Conditions',
    //   //     route: '/site_policy/terms_conditions'
    //   //   }
    //   // ]
    // },

  ];

}